import React, { ReactElement } from 'react';

/** When given a string containing new line characters, returns a React Fragment (and children) containing the text with
 * new line characters converted to BR elements
 */
export function convertNewLinesToBr(text: string) {
  const [firstLine, ...otherLines] = text.split('\n');
  return (
    <>
      {firstLine}
      {otherLines.map((item, index) => (
        <React.Fragment key={index}>
          <br />
          {item}
        </React.Fragment>
      ))}
    </>
  );
}

/** Joins the provided react elements with a separator. e.g. useful for joining values with commas when those values
 * need HTML formatting - using arrayValues.join(',') would only work for plain-text
 */
export function jsxJoin(
  elements: (ReactElement | string)[],
  separator: ReactElement | string,
): ReactElement | null {
  if (elements.length === 0) {
    return null;
  }
  const [first, ...others] = elements;
  return (
    <>
      {first}
      {others.map((item, index) => (
        <React.Fragment key={index}>
          {separator}
          {item}
        </React.Fragment>
      ))}
    </>
  );
}
